import React, { useState } from "react";
import useAxiosInstance from "../../hooks/useAxiosInstance";
import { CircularProgress, IconButton } from "@mui/material";
import { API_RESULT, API_VERSION } from "../../enums/common.enum";
import { errorToast, handleError } from "../../utils/common";
import UtrTxnModal from "./utrTxnModal";
import OcrIcon from "../../assets/images/ocr.svg";

const OcrButton = ({ item }: any) => {
  const [fetchingUtr, setFetchingUtr] = useState(false);
  const privateInstance = useAxiosInstance();
  const [utrTxnData, setUtrTxnData] = useState(null);
  const [utrTxnModal, setUtrTxnModal] = useState(false);

  const getUtrAndTxn = async (imgUrl: string) => {
    const payload = {
      type: "image_to_utr",
      image_url: imgUrl,
    };

    try {
      setFetchingUtr(true);
      const result = await privateInstance.post(
        `${API_VERSION.V3}/openai`,
        payload
      );
      if (result?.data?.status === API_RESULT.SUCCESS) {
        setUtrTxnData(result.data.response);
        setUtrTxnModal(true);
      } else {
        if (
          result?.data?.message?.toLowerCase()?.includes("unable to fetch utr")
        ) {
          setUtrTxnData(result?.data?.message);
          setUtrTxnModal(true);
        } else {
          errorToast(result?.data?.message);
        }
      }
    } catch (err) {
      handleError(err);
    } finally {
      setFetchingUtr(false);
    }
  };

  return (
    <>
      <>
        {fetchingUtr ? (
          <CircularProgress
            size={28}
            sx={{
              position: "absolute",
              top: "calc(50% - 12px)",
              left: "calc(50% - 12px)",
            }}
          />
        ) : null}
        <IconButton
          disabled={fetchingUtr}
          onClick={(e) => {
            e.stopPropagation();
            getUtrAndTxn(item);
          }}
          size="large"
          sx={{
            position: "absolute",
            bottom: "6px",
            right: "6px",
            backgroundColor: "#fff",
            "&:hover": {
              backgroundColor: "#fff",
              boxShadow: "0 0 12px #0058ff",
            },
          }}
        >
          <img
            src={OcrIcon}
            alt="ocr icon"
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        </IconButton>
      </>

      {utrTxnModal ? (
        <UtrTxnModal
          open={utrTxnModal}
          onClose={() => setUtrTxnModal(false)}
          data={utrTxnData}
          setData={setUtrTxnData}
        />
      ) : null}
    </>
  );
};

export default OcrButton;
